import Detail from "../../../components/Details/Detail"
import { GLOBAL_CONSTANTS, LABEL_TXT } from "../../../constants/constants"
import { useSelector } from "react-redux"
import { Spin } from "antd"

const DirectorDetails = ({ directorDetailsData }) => {
  const { loading } = useSelector((state) => state?.business);

  return (
    <div className="details-card-container">
      <div className="details-card">
        <Spin spinning={loading}>
          <div className="details-content">
            <Detail
              label={LABEL_TXT.DIR_NAME}
              value={directorDetailsData?.directorDetails?.directorName || GLOBAL_CONSTANTS.NA}
              isVerified={directorDetailsData?.kycDetails?.kycDirectorsPanValue?.isVerified}
            />
            <Detail
              label={LABEL_TXT.DIR_PAN}
              value={directorDetailsData?.kycDetails?.kycDirectorsPanValue?.docValue || GLOBAL_CONSTANTS.NA}
              isVerified={directorDetailsData?.kycDetails?.kycDirectorsPanValue?.isVerified}
            />
            <Detail
              label={LABEL_TXT.DIR_AADHAR}
              value={directorDetailsData?.kycDetails?.kycDirectorsAadhaarValue?.docValue || GLOBAL_CONSTANTS.NA}
              isVerified={directorDetailsData?.kycDetails?.kycDirectorsAadhaarValue?.isVerified}
            />
            <Detail
              label={LABEL_TXT.DIR_PIC}
              value={directorDetailsData?.kycDetails?.kycDirectorsPicture?.docUrl || GLOBAL_CONSTANTS.NA}
              isVerified={directorDetailsData?.kycDetails?.kycDirectorsPicture?.isVerified}
              isImg={true}
            />
          </div>
        </Spin>
      </div>
    </div>
  )
}

export default DirectorDetails